import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "@/lib/admin-api";

export default function ProtectedAdmin() {
  const token = getToken();
  if (!token) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
